import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

const initialState = [];

const notification = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setNotification: (state, { payload }) => {
      const stateToUpdate =
        state.findIndex(({ id }) => id === payload.id) === -1
          ? state
          : state.filter(({ id }) => id !== payload.id);

      return [
        ...stateToUpdate,
        {
          variant: payload.variant,
          content: payload.content,
          title: payload.title,
          id: payload.id || uuidv4(),
          disappear: payload.disappear,
        },
      ];
    },
    removeNotification: (state, action) => {
      return state.filter(item => action.payload.id !== item.id);
    },
  },
});

export const { setNotification, removeNotification } = notification.actions;
export default notification.reducer;
